var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "mb-4 flex justify-between" },
      [
        _c("h1", { staticClass: "font-sans text-n-gray-dark" }, [
          _vm._v("Categories"),
        ]),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "pl-4 self-center",
            attrs: { to: { name: "category-create" } },
          },
          [_vm._v("\n            Add a new category\n        ")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "responsive-table" }, [
      _c(
        "table",
        { staticClass: "w-full" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm._l(_vm.categories, function (category) {
            return _c("category-item", {
              key: category.id,
              attrs: { category: category },
            })
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-left p-2 border border-grey-light" }, [
          _vm._v("Title"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left p-2 border border-grey-light" }, [
          _vm._v("Slug"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left p-2 border border-grey-light" }, [
          _vm._v("Group"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }